<template>
  <Transition name="modal">
    <div v-if="show" class="m-mask" v-hotkey="keymap">
      <div class="m-container" :style="{ width, height }">
        <img
          v-if="!lottieShow"
          src="/img/close-gray.svg"
          width="19px"
          height="19px"
          alt="close"
          @click="close($event, true)"
        />
        <div
          class="m-content d-flex flex-column justify-center align-center"
          :style="{ 'margin-bottom': btnShow ? '25px' : '' }"
        >
          <img
            v-if="iconShow"
            class="icon"
            src="/img/icon-symbol.svg"
            width="50px"
            height="50px"
            alt="symbol"
          />

          <c-lottie
            v-if="lottieShow"
            class="icon"
            :options="lottieOptions"
            :width="50"
            :height="50"
          />
          <c-lottie
            v-if="type !== 'plane'"
            class="icon"
            :options="
              type === 'plane'
                ? lottieOptions
                : type === 'notification'
                ? lottieNotice
                : lottieUpdate
            "
            :width="50"
            :height="50"
          />
          <div
            v-if="type === 'notification' || type === 'update'"
            class="title"
          >
            {{ title }}
          </div>
          <slot></slot>
          <div v-if="type === 'notification'" class="date">{{ date }}</div>
        </div>
        <div v-if="btnShow" class="m-btn d-flex justify-center">
          <c-button
            :class="negativeBtnOpts.bgColor"
            style="margin-right: 6px"
            height="50px"
            fontSize="14px"
            fontWeight="600"
            :fill="negativeBtnOpts.fill"
            v-if="negativeBtnOpts.show"
            v-bind="negativeBtnOpts"
            @click="close"
          >
            {{ negativeBtnOpts.text }}
          </c-button>
          <c-button
            :class="positiveBtnOpts.bgColor"
            height="50px"
            fontSize="14px"
            fontWeight="600"
            :fill="positiveBtnOpts.fill"
            v-if="positiveBtnOpts.show"
            v-bind="positiveBtnOpts"
            @click="submit"
          >
            <img
              v-if="positiveBtnOpts.prependIcon"
              :src="positiveBtnOpts.prependIcon"
              class="mr-1"
              alt="icon"
            />
            {{ positiveBtnOpts.text }}
          </c-button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import CButton from "@/components/designSystem/CButton.vue";
import CLottie from "@/components/Lotties/CLottie.vue";
import * as Lottie from "@/assets/lotties/loading-spinner-blue.json";
import * as Update from "@/assets/lotties/update.json";
import * as Notice from "@/assets/lotties/check-notice.json";

export default {
  components: {
    "c-button": CButton,
    "c-lottie": CLottie,
  },
  props: {
    /** 모달 show (sync) */
    open: {
      type: Boolean,
      default: () => false,
    },
    /** modal width */
    width: {
      type: String,
      default: () => "",
    },
    /** modal height */
    height: {
      type: String,
      default: () => "",
    },
    /** icon show */
    iconShow: {
      type: Boolean,
      default: () => false,
    },
    /** lottie show */
    lottieShow: {
      type: Boolean,
      default: () => false,
    },
    /** button show */
    btnShow: {
      type: Boolean,
      default: () => true,
    },
    /** negative btn options */
    negativeBtnOptions: {
      type: Object,
      default: () => {
        return {};
      },
    },
    /** positive btn options */
    positiveBtnOptions: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: () => {
        return "plane";
      },
    },
    /** esc로 모달 닫기 */
    escapeAllowed: {
      type: Boolean,
      default: () => false,
    },
    title: {
      type: String,
      default: () => "",
    },
    date: {
      type: String,
      default: () => "",
    },
  },
  computed: {
    keymap() {
      return {
        escape: {
          keydown: (e) => {
            if (!this.escapeAllowed) return;
            this.close(e, true);
          },
        },
      };
    },
    negativeBtnOpts() {
      return {
        show: true,
        width: "94px",
        fill: true,
        ...this.defaultOptions.negative,
        ...this.negativeBtnOptions,
      };
    },
    positiveBtnOpts() {
      return {
        show: true,
        width: "200px",
        fill: true,
        ...this.defaultOptions.positive,
        ...this.positiveBtnOptions,
      };
    },
  },
  data: () => {
    return {
      show: false,
      lottieNotice: { animationData: Notice },
      lottieUpdate: { animationData: Update },
      lottieOptions: { animationData: Lottie },
      defaultOptions: {
        positive: {
          text: "확인",
          bgColor: "blue-primary",
        },
        negative: {
          text: "취소",
          bgColor: "gray",
        },
      },
    };
  },
  watch: {
    open() {
      this.show = this.open;
    },
  },
  mounted() {
    this.show = this.open;
  },
  methods: {
    submit() {
      this.$emit("submit");
    },
    close(_, escape) {
      // escape true: X or ESC 누름
      this.$emit("update:open", false);
      this.$emit("cancel", escape);
      this.$emit("close", escape);
    },
  },
};
</script>

<style lang="scss" scoped>
.m-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(51, 51, 51, 0.4);
  backdrop-filter: blur(2.5px);
  display: flex;
  transition: opacity 0.3s ease;
  padding: 100px;

  & > .m-container {
    border-radius: 10px;
    position: relative;
    margin: auto;
    padding: 20px 20px 65px 20px;
    background-color: #fff;
    box-shadow: -4px 4px 20px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;

    & > img {
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }

    & > .m-content {
      margin-top: 44px;
      text-align: center;

      font-size: 18px !important;
      font-weight: 500;
      line-height: 23.94px;
      white-space: pre-line;
      color: var(--m-gray00);

      & > .icon {
        margin-bottom: 25px !important;
      }
    }
  }
}

.modal-enter {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter .m-container,
.modal-leave-to .m-container {
  -webkit-transform: scale(1.1) !important;
  transform: scale(1.1) !important;
}
.title {
  margin-bottom: 10px;
  text-align: center;

  /* Title3 600 */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 23.9px; /* 132.778% */
  &.noti {
    color: var(--secondary-s-red00, #ec1010);
  }
}
.date {
  margin-top: 10px;
  display: flex;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 10px;
  background: var(--mono-m-gray-04-mouse-over, #f5f5f5);
  color: var(--secondary-s-red00, #ec1010);
  text-align: center;

  /* Title4 700 */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 21.3px; /* 133.125% */
}
</style>
